import styled from "styled-components";

export const ModalBody = styled.div`
  display: grid;
  text-align: center;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
`;
export const ErrorList = styled.ul`
  max-height: 200px;
  overflow-y: auto;
  margin: 0.5rem 0 0;
  padding-left: 1.25rem;
  text-align: left;
`;
export const Success = styled.div`
  display: flex;
  gap: 1rem;
  align-items: start;
`;